import React, { useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import axios from "axios";
import CurrencyService from "../../../Services/QRCodeServices/CurrencyService/CurrencyService";

const EditCurrency = ({ isOpen, toggleModal, data, refreshData }) => {
  // Initial values for the form
  const initialValues = {
    title: data?.title || "",
    currencyCode: data?.currencyCode || "",
    description: data?.description || "",
  };

  // Validation schema using Yup
  const validationSchema = Yup.object({
    title: Yup.string()
      .required("Title is required")
      .max(50, "Title cannot exceed 50 characters"),
    currencyCode: Yup.string()
      .required("Currency code is required")
      .max(10, "Currency code cannot exceed 10 characters"),
    description: Yup.string().max(
      255,
      "Description cannot exceed 255 characters"
    ),
  });

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      const response = await CurrencyService.update(data.id, values);

      toast.success("Currency updated successfully");
      toggleModal();
      refreshData();
    } catch (error) {
      console.error("Error updating currency:", error);
      toast.error("Failed to update currency. Please try again.");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size="md">
      <ModalHeader toggle={toggleModal}>Edit Currency</ModalHeader>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {() => (
            <Form>
              <FormGroup>
                <Label for="title">Title</Label>
                <Field
                  name="title"
                  type="text"
                  className="form-control"
                  id="title"
                  placeholder="Enter title (e.g., Nepali)"
                />
                <ErrorMessage
                  name="title"
                  component="div"
                  className="text-danger"
                />
              </FormGroup>

              <FormGroup>
                <Label for="currencyCode">Currency Code</Label>
                <Field
                  name="currencyCode"
                  type="text"
                  className="form-control"
                  id="currencyCode"
                  placeholder="Enter currency code (e.g., NRS)"
                />
                <ErrorMessage
                  name="currencyCode"
                  component="div"
                  className="text-danger"
                />
              </FormGroup>

              <FormGroup>
                <Label for="description">Description</Label>
                <Field
                  name="description"
                  as="textarea"
                  className="form-control"
                  id="description"
                  placeholder="Enter description"
                />
                <ErrorMessage
                  name="description"
                  component="div"
                  className="text-danger"
                />
              </FormGroup>

              <ModalFooter>
                <Button color="secondary" onClick={toggleModal}>
                  Cancel
                </Button>
                <Button color="primary" type="submit">
                  Update
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default EditCurrency;
